export default __webpack_public_path__ + "static/media/bc-avatar-builder-green.55c7c59a.svg";